import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { BRAND_CURATION_TASKS_QUERY } from '../graphql/queries'
import { FETCH_BRAND_CURATION_TASKS } from '../redux/action-types'
import { cleanupFetchBrandCurationTasks } from '../redux/actions'

const useBrandCurationTasksQuery = (
  {
    taskStatus,
    autoeatStatus,
    searchText,
    assignedCurator,
    assignedQa,
    assignedQc,
    isCurationDone,
    isQaDone,
    isQcDone,
    duplicate,
  } = {},
  { pageSize, currentPage } = {},
) => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchBrandCurationTasks)

  const { isLoading, error, data } = useSelector(
    store => store.brandCurationTasks.brandCurationTasks,
  )

  const refetch = useCallback(
    (filtersParam, paginationParam) =>
      apolloService.query({
        query: BRAND_CURATION_TASKS_QUERY,
        variables: {
          filters: filtersParam,
          pagination: paginationParam,
        },
        dispatch,
        action: FETCH_BRAND_CURATION_TASKS,
      }),
    [dispatch],
  )

  useEffect(() => {
    refetch(
      {
        taskStatus,
        autoeatStatus,
        searchText,
        assignedCurator,
        assignedQa,
        assignedQc,
        isCurationDone,
        isQaDone,
        isQcDone,
        duplicate,
      },
      { pageSize, currentPage },
    )
  }, [
    refetch,
    pageSize,
    currentPage,
    taskStatus,
    autoeatStatus,
    searchText,
    assignedCurator,
    assignedQa,
    isCurationDone,
    isQaDone,
    assignedQc,
    isQcDone,
    duplicate,
  ])

  return { isLoading, error, data }
}

export default useBrandCurationTasksQuery
